module.exports = __webpack_public_path__ + "media/images/database_save-da415434f355be27009114d4ac498341.png";